import axios from 'axios';

import { apiRoutes } from '../config/routes';

export const uploadRpeepDocument = async (personId: number, file: File) => {
  const formData = new FormData();

  formData.append('file', file);

  // Axios automatically sets the necessary headers
  await axios.post(apiRoutes.uploadRpeep(personId), formData);
};
